/**
 * Automatic Discount Display - Simple Event Listener
 *
 * Listens for variant price changes and applies discount based on product tags
 * (e.g., _discount_25 for 25% off)
 *
 * @version 2.0 - Simplified
 */

(function() {
  'use strict';

  // Money formatting function with fallbacks
  function formatMoney(cents, format) {
    // Try Shopify.formatMoney first (always available on Shopify stores)
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || theme.moneyFormat || null);
    }

    // Fallback to simple dollar formatting
    var value = cents / 100;
    return '$' + value.toFixed(2).replace(/\.00$/, '');
  }

  // Function to update price with discount
  function updateDiscountPrice(container, variant) {
    console.log('🔧 updateDiscountPrice called with variant:', variant);

    var priceElement = container.querySelector('[data-product-price]');
    if (!priceElement) {
      console.log('❌ No price element found with [data-product-price]');
      return;
    }

    var autoDiscountPercent = priceElement.dataset.autoDiscountPercent;
    console.log('📊 Discount percent from element:', autoDiscountPercent);

    if (!autoDiscountPercent || parseFloat(autoDiscountPercent) <= 0) {
      console.log('❌ No valid discount percent found');
      return;
    }

    var autoDiscountOriginal = container.querySelector('[data-auto-discount-original]');
    var autoDiscountSavings = container.querySelector('[data-auto-discount-savings]');

    console.log('💰 Applying discount:', autoDiscountPercent + '%', 'to price:', variant.price);
    console.log('📦 Elements found:', {
      original: autoDiscountOriginal,
      savings: autoDiscountSavings
    });

    // Check if there's a regular sale first (compare_at_price)
    if (variant.compare_at_price > variant.price) {
      console.log('⚠️ Product already on sale, skipping automatic discount');
      // Hide automatic discount elements
      if (autoDiscountOriginal) autoDiscountOriginal.classList.add('hide');
      if (autoDiscountSavings) autoDiscountSavings.classList.add('hide');
      return;
    }

    // Calculate discounted price
    var discountMultiplier = (100 - parseFloat(autoDiscountPercent)) / 100;
    var discountedPrice = variant.price * discountMultiplier;

    console.log('✅ Discounted price:', discountedPrice);

    // Update price display
    priceElement.innerHTML = formatMoney(discountedPrice, theme.moneyFormat);
    priceElement.classList.add('on-sale');

    // Show/update original price
    if (autoDiscountOriginal) {
      autoDiscountOriginal.innerHTML = formatMoney(variant.price, theme.moneyFormat);
      autoDiscountOriginal.classList.remove('hide');
    }

    // Calculate and show savings
    var savings = variant.price - discountedPrice;
    var saveType = (theme.settings && theme.settings.saveType) || 'dollar';
    if (saveType === 'percent') {
      savings = autoDiscountPercent + '%';
    } else {
      savings = formatMoney(savings, theme.moneyFormat);
    }

    if (autoDiscountSavings) {
      autoDiscountSavings.classList.remove('hide');
      var saveString = (theme.strings && theme.strings.savePrice) || 'Save [saved_amount]';
      autoDiscountSavings.innerHTML = saveString.replace('[saved_amount]', savings);
    }

    // Update Recharge widget with the same variant price
    var productContainer = container.closest('[data-section-type="product"]');
    if (productContainer) {
      updateRechargeWidget(productContainer, variant, autoDiscountPercent, false);
    }
  }

  // Function to update Recharge widget price
  function updateRechargeWidget(container, variant, autoDiscountPercent, isPageLoad) {
    if (!autoDiscountPercent || parseFloat(autoDiscountPercent) <= 0) {
      return;
    }

    // Skip if product is already on sale (only if we have variant data)
    if (variant && variant.price > 0 && variant.compare_at_price > variant.price) {
      return;
    }

    // Find the Recharge widget container (the empty div that will be populated)
    var rechargeContainer = container.querySelector('[id^="RechargeWidget_"]');
    if (!rechargeContainer) {
      console.log('DEBUG: Recharge container not found');
      return;
    }

    var discountMultiplier = (100 - parseFloat(autoDiscountPercent)) / 100;
    var variantPrice = variant && variant.price > 0 ? variant.price : null;

    // Only delay on page load, variant changes update immediately
    var delay = isPageLoad ? 2000 : 0;

    if (isPageLoad) {
      console.log('DEBUG: Page load - waiting 2 seconds for Recharge to fully render. Variant price:', variantPrice);
    } else {
      console.log('🔄 Variant change - updating Recharge widget immediately. Variant price:', variantPrice);
    }

    // Wait for Recharge to fully render (only on page load), then directly update price
    setTimeout(function() {
      console.log('DEBUG: Looking for price elements in Recharge widget...');

      // Try multiple selectors to find the one-time price element
      var priceSelectors = [
        'label[for*="onetime"] span',
        '[class*="onetime"] [class*="price"]',
        'input[type="radio"][value=""] + label span',
        '[class*="radio"]:first-child span',
        'label span',
        'span'
      ];

      var onetimeLabel = null;
      for (var i = 0; i < priceSelectors.length; i++) {
        var elements = rechargeContainer.querySelectorAll(priceSelectors[i]);
        console.log('DEBUG: Trying selector "' + priceSelectors[i] + '", found', elements.length, 'elements');
        // Look for element that contains a price format ($ or number)
        for (var j = 0; j < elements.length; j++) {
          if (elements[j].textContent.includes('$') || /\d/.test(elements[j].textContent)) {
            onetimeLabel = elements[j];
            console.log('✅ Found price element with selector:', priceSelectors[i], 'text:', elements[j].textContent);
            break;
          }
        }
        if (onetimeLabel) break;
      }

      if (onetimeLabel) {
        var discountedPrice;

        // If we have variant price from event, use it
        if (variantPrice) {
          discountedPrice = variantPrice * discountMultiplier;
          console.log('DEBUG: Using variant price:', variantPrice, '→', discountedPrice);
        } else {
          // On page load, parse the price from Recharge's display and apply discount
          var rechargePrice = onetimeLabel.textContent.replace(/[^0-9.]/g, '');
          var priceInCents = parseFloat(rechargePrice) * 100;
          discountedPrice = priceInCents * discountMultiplier;
          console.log('DEBUG: Parsed Recharge price:', rechargePrice, '→', priceInCents, '→', discountedPrice);
        }

        var formattedPrice = formatMoney(discountedPrice, theme.moneyFormat);
        console.log('DEBUG: Updating price from', onetimeLabel.textContent, 'to', formattedPrice);
        onetimeLabel.textContent = formattedPrice;
        console.log('✅ Recharge widget price updated successfully');
      } else {
        console.log('❌ Could not find price element in Recharge widget');
        console.log('DEBUG: Widget HTML:', rechargeContainer.innerHTML.substring(0, 500));
      }
    }, delay); // Delay only on page load
  }

  // Initialize on page load
  function init() {
    console.log('🚀 Automatic Discount: Initializing...');

    // Find all product containers
    var productContainers = document.querySelectorAll('[data-section-type="product"]');
    console.log('🔍 Found', productContainers.length, 'product containers');

    productContainers.forEach(function(container) {
      // Check if this product has an automatic discount
      var priceElement = container.querySelector('[data-product-price]');
      var autoDiscountPercent = priceElement ? priceElement.dataset.autoDiscountPercent : null;

      console.log('📦 Product container found');
      console.log('💲 Price element:', priceElement);
      console.log('🏷️ Discount percent from data attribute:', autoDiscountPercent);

      if (!autoDiscountPercent || parseFloat(autoDiscountPercent) <= 0) {
        console.log('ℹ️ No automatic discount for this product');
        // Still set up event listeners even if no discount, in case variant changes
      } else {
        console.log('✅ Automatic discount detected:', autoDiscountPercent + '%');
      }

      // Simple retry - just wait for Recharge div to appear
      console.log('📍 Setting up Recharge widget watcher...');
      var attempts = 0;
      var maxAttempts = 20;

      var checkForRecharge = setInterval(function() {
        attempts++;
        var rechargeContainer = container.querySelector('[id^="RechargeWidget_"]');

        if (rechargeContainer) {
          console.log('✅ Recharge widget div found!');
          clearInterval(checkForRecharge);

          // Re-check discount percent in case it was added dynamically
          var priceElement = container.querySelector('[data-product-price]');
          var autoDiscountPercent = priceElement ? priceElement.dataset.autoDiscountPercent : null;

          console.log('DEBUG: Final discount percent check:', autoDiscountPercent);

          if (autoDiscountPercent && parseFloat(autoDiscountPercent) > 0) {
            console.log('DEBUG: Calling updateRechargeWidget for page load with', autoDiscountPercent + '%');
            // Create a minimal variant object - updateRechargeWidget will get the price from Recharge itself
            updateRechargeWidget(container, { price: 0, compare_at_price: 0 }, autoDiscountPercent, true);
          }
        } else if (attempts >= maxAttempts) {
          console.log('⏱️ Recharge widget not found after 10 seconds');
          clearInterval(checkForRecharge);
        }
      }, 500);


      // Listen for Pipeline theme variant changes
      container.addEventListener('theme:variant:change', function(event) {
        console.log('🔄 Variant changed (Pipeline theme event)!', event.detail.variant);
        var variant = event.detail.variant;
        if (!variant) return;

        // Update discount price display
        updateDiscountPrice(container, variant);

        // Also update Recharge widget
        var priceElement = container.querySelector('[data-product-price]');
        if (priceElement) {
          var autoDiscountPercent = priceElement.dataset.autoDiscountPercent;
          updateRechargeWidget(container, variant, autoDiscountPercent, false);
        }
      });
    });

    // Also add a global listener to catch all variant changes (backup for dynamically loaded products)
    document.addEventListener('theme:variant:change', function(event) {
      console.log('🌍 Global variant change detected', event.detail.variant);

      // Find the product container that triggered this event
      var productContainer = event.target.closest('[data-section-type="product"]');
      if (!productContainer) {
        console.log('❌ Could not find product container from event target');
        return;
      }

      var variant = event.detail.variant;
      if (!variant) return;

      // Update discount price
      updateDiscountPrice(productContainer, variant);

      // Update Recharge widget
      var priceElement = productContainer.querySelector('[data-product-price]');
      if (priceElement) {
        var autoDiscountPercent = priceElement.dataset.autoDiscountPercent;
        if (autoDiscountPercent) {
          console.log('💰 Global listener: Updating with discount', autoDiscountPercent + '%');
          updateRechargeWidget(productContainer, variant, autoDiscountPercent, false);
        }
      }
    });

    console.log('✅ Automatic Discount: Ready!');
  }

  // Wait for page to load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // Small delay to ensure theme object is set up
    setTimeout(init, 100);
  }

})();